const axios = require('axios')
const jsonapi = require('jsonapi-parse')

// Create a separate axios instance for token fetching to avoid circular dependency
const tokenApi = axios.create({
  baseURL: process.env.REACT_APP_API_ROOT,
  transformResponse: (data) => {
    return jsonapi.parse(data)
  }
});

// Add interceptor to tokenApi to use authHeaders for authentication
tokenApi.interceptors.request.use((config) => {
  const authHeaders = JSON.parse(sessionStorage.getItem('authHeaders') || '{}');
  config.headers = { ...config.headers, ...authHeaders };
  return config;
});

const getRequestHeaders = async () => {
  let auth = JSON.parse(sessionStorage.getItem('authHeaders'));
  if (!auth || Object.keys(auth).length === 0) {
    // Fail fast - don't attempt token fetching without valid authHeaders
    throw new Error('Authentication required - no valid auth headers found');
  }

  // Check if we have a token in session storage
  let token = sessionStorage.getItem('get_token');

  if (!token) {
    try {
      // Make API call to fetch token - this will only work if user is properly authenticated
      const response = await tokenApi.get('/token/fetch_get_token');

      if (response.data && response.data.token) {
        token = response.data.token;
        // Store token in session storage for future use
        sessionStorage.setItem('get_token', token);
      } else {
        throw new Error('Invalid token response format');
      }
    } catch (error) {
      console.error('Failed to fetch authentication token:', error);
      // Clear any existing auth data on failure for security
      sessionStorage.removeItem('authHeaders');
      sessionStorage.removeItem('get_token');
      throw new Error('Authentication failed - unable to fetch token');
    }
  }

  // Set the authorization header with the token
  if (token) {
    auth.Authorization = `Token token=${token}`;
  }

  return auth;
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ROOT,
  transformResponse: (data) => {
    return jsonapi.parse(data)
  }
});

// Add request interceptor to set headers dynamically for each request
api.interceptors.request.use(async (config) => {
  try {
    const headers = await getRequestHeaders();
    config.headers = { ...config.headers, ...headers };
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
});

// Note(Dennis): Used this function for not getting undefined value of header in /auth/home page when using the api lib
function loginApi() {
  // Return an axios instance that uses the same interceptor as the main api
  // This maintains backward compatibility while still using secure token management
  const loginApiInstance = axios.create({
    baseURL: process.env.REACT_APP_API_ROOT,
    transformResponse: (data) => {
      return jsonapi.parse(data)
    }
  });

  // Add the same request interceptor as the main api instance
  loginApiInstance.interceptors.request.use(async (config) => {
    try {
      const headers = await getRequestHeaders();
      config.headers = { ...config.headers, ...headers };
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  });

  return loginApiInstance;
}

export {api, loginApi, getRequestHeaders}
